import {
  getMoneyFormattingOptions,
  parseFormattedMoneyValue,
} from 'helpers/numberFormatting';
import _ from 'lodash';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { getId } from 'office-ui-fabric-react/lib/Utilities';
import React, { Component, Fragment } from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import './style.css';

export default class MoneyField extends Component {
  hostId = getId('tooltipHost');

  componentWillMount() {
    const { currency, locale, allowDecimal } = this.props;

    this.options = getMoneyFormattingOptions(currency, locale);

    const _mask = createNumberMask({
      prefix: '',
      suffix: this.options.fixedDecimalZeroes
        ? this.options.decimal + _.repeat('0', this.options.fixedDecimalZeroes)
        : '',
      includeThousandsSeparator: !!this.options.group,
      thousandsSeparatorSymbol: this.options.group,
      decimalSymbol: this.options.decimal,
      integerLimit: 8,
      allowDecimal: allowDecimal,
      decimalLimit: 2,
      // allowNegative: false,
      // allowLeadingZeroes: false,
    });

    this.mask = allowDecimal
      ? _mask
      : function (rawValue) {
          const numericValue = parseFormattedMoneyValue(
            rawValue,
            currency,
            locale
          );
          return _mask(numericValue.toString());
        };

    this.id = _.uniqueId('MoneyField');
  }

  handleChanged = (e) => {
    const { onChanged, currency, locale, allowDecimal } = this.props;
    if (onChanged) {
      onChanged(
        allowDecimal
          ? e.target.value
          : parseFormattedMoneyValue(e.target.value, currency, locale)
      );
    }
  };

  render() {
    const { value, label, required, tooltip, description } = this.props;
    const { errorMessage, allowDecimal, ...fieldProps } = this.props;

    let propsForwarded = Object.assign({}, fieldProps);
    delete propsForwarded.onChanged; // <MaskedInput> does not support 'onChanged' attribute

    return (
      <div
        className={
          'ms-MoneyField ms-TextField ' + (!!required ? 'is-required' : '')
        }
      >
        <div className="ms-TextField-wrapper">
          {label && (
            <label
              className="ms-Label"
              required={required || false}
              htmlFor={this.id}
              style={{
                paddingTop: '5px',
                paddingBottom: '5px',
                display: 'inline-block',
              }}
            >
              {label}
              {tooltip && (
                <Fragment>
                  {' '}
                  <TooltipHost
                    content={tooltip}
                    id={this.hostId}
                    calloutProps={{ gapSpace: 0 }}
                  >
                    <Icon iconName="Info" />
                  </TooltipHost>
                </Fragment>
              )}
            </label>
          )}
          <div className="ms-TextField-fieldGroup">
            {this.options.prefix && (
              <div className="ms-TextField-prefix">
                <span style={{ paddingBottom: '1px' }}>
                  {this.options.prefix}
                </span>
              </div>
            )}
            <MaskedInput
              {...propsForwarded}
              id={this.id}
              mask={this.mask}
              value={value}
              onChange={this.handleChanged}
              className={
                'ms-TextField-field' +
                (this.props.className ? ' ' + this.props.className : '')
              }
              inputMode="numeric"
            />
            {this.options.suffix && (
              <div className="ms-TextField-suffix">
                <span style={{ paddingBottom: '1px' }}>
                  {this.options.suffix}
                </span>
              </div>
            )}
          </div>
          {description && (
            <div style={{ fontSize: '11px', paddingTop: '8px', color: '#666' }}>
              <span className="ms-TextField-description">{description}</span>
            </div>
          )}
          {errorMessage && errorMessage !== '' && (
            <div>
              <p className="errorMessage">
                <span>{errorMessage}</span>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/MoneyField/index.jsx